/* import __COLOCATED_TEMPLATE__ from './boolean-filter.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { type Filter, Operator, type Predicate } from '../steps/filter';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

interface Args {
  filter: Filter;
  index: number;
  removeFilter: (index: number) => void;
  setPredicate: (predicate: any, index: number) => void;
}

export default class StandaloneSalesforceSetupArticleSyncFilterItemsBooleanFilter extends Component<Args> {
  @tracked selected = this.initialSelectedValue;

  get initialSelectedValue() {
    if (this.args.filter.predicate.value === undefined) {
      return false;
    }

    return this.args.filter.predicate.value as boolean;
  }

  get predicate(): Predicate {
    return {
      ...this.args.filter.predicate,
      operator: Operator.Equal,
      value: this.selected,
    };
  }

  get filterBlockDetails() {
    return `${Operator.Equal} ${this.selected}`;
  }

  @action
  onClose() {
    this.args.setPredicate(this.predicate, this.args.index);
  }

  @action
  removeFilter() {
    this.args.removeFilter(this.args.index);
  }

  @action
  setSelected(selected: boolean) {
    this.selected = selected;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Salesforce::Setup::ArticleSync::FilterItems::BooleanFilter': typeof StandaloneSalesforceSetupArticleSyncFilterItemsBooleanFilter;
    'standalone/salesforce/setup/article-sync/filter-items/boolean-filter': typeof StandaloneSalesforceSetupArticleSyncFilterItemsBooleanFilter;
  }
}
